import { http } from '../http';

export class MyGooruAPI {

    static get instance() {
        return this.INSTANCE;
    }

    private static INSTANCE = new MyGooruAPI();

    private namespace  = 'api/v1/admin-utils';
    private namespace1 = 'api/mygooru/v1';
    private namespace2 = 'api/nucleus-auth/v1/mygooru';
    private namespace3 = 'api/admin/v1/nudge-config-master';
    private namespace4 = 'api/admin/v1/nudge-types';

    public getTenantList(params: any) {
        const endpoint =  `${this.namespace}/tenant`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header, params).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getLearnerInterest() {
        const endpoint =  `${this.namespace1}/learner/interest`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header ).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public getMyGooruAccessCreate(data: any) {
        const endpoint =  `${this.namespace2}/access/create`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header , data ).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public getMygooruAccessList(params: any) {
        const endpoint =  `${this.namespace2}/access`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header , params).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public saveAccessList(params: any) {
        const endpoint =  `${this.namespace2}/access`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header , params).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public getNudgeConfigList(params: any) {
        const endpoint =  `${this.namespace3}/list`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header, params).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public fetchNudgeProperties() {
        const endpoint = `${this.namespace3}/properties`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public createNudgeMappig(data: any) {
        const endpoint = `${this.namespace3}`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, data)
        .then((response) => {
            return response;
        })
        .catch((error: any) => {
            // If the server returns a 409 Conflict
            if (error.response.status === 409) {
                return {
                    success: false,
                    status: 409,
                    message: 'Conflict: Nudge mapping already exists',
                    data: error.response.data || null,
                };
            }
            return {
                success: false,
                status: error.response.status || 500,
                message: 'Something went wrong',
                data: error.response.data || null,
            };
        });
    }
    public updateNudgeMapping(id: number, data: any) {
        const endpoint = `${this.namespace3}/${id}`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header, data).then((response) => {
            return response;
        }).catch((error: any) => {
            // If the server returns a 409 Conflict
            if (error.response.status === 409) {
                return {
                    success: false,
                    status: 409,
                    message: 'Conflict: Nudge mapping already exists',
                    data: error.response.data || null,
                };
            }
            return {
                success: false,
                status: error.response.status || 500,
                message: 'Something went wrong',
                data: error.response.data || null,
            };
        });
    }
    public fetchNudgeTypes() {
        const endpoint = `${this.namespace4}`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error'};
        });
    }
    public createNudgeType(data: any) {
        const endpoint = `${this.namespace4}/create`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, data).then((response) => {
            return response;
        }).catch((error: any) => {
            // If the server returns a 409 Conflict
            if (error.response.status === 409) {
                return {
                    success: false,
                    status: 409,
                    message: 'Conflict: Key already exists',
                    data: error.response.data || null,
                };
            }
            return {
                success: false,
                status: error.response.status || 500,
                message: 'Something went wrong',
                data: error.response.data || null,
            };
        });
    }
    public updateNudgeType(id: number, data: any) {
        const endpoint = `${this.namespace4}/${id}`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header, data).then((response) => {
            return response;
        }).catch((error: any) => {
            // If the server returns a 409 Conflict
            if (error.response.status === 409) {
                return {
                    success: false,
                    status: 409,
                    message: 'Conflict: Key already exists',
                    data: error.response.data || null,
                };
            }
            return {
                success: false,
                status: error.response.status || 500,
                message: 'Something went wrong',
                data: error.response.data || null,
            };
        });
    }
}
export const myGooruAPI = MyGooruAPI.instance;


